<template>
  <div>
    <!-- Main Dialog -->
    <v-dialog :value="value" @input="v => v || close()" max-width="400px">
      <v-card>
        <v-card-title>
          <span class="headline">動画アップロード</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <span>* は必須項目です。</span>
            <v-form
                ref="droneImageUploadForm"
            >
              <v-row class="div-images-upload">
                <v-col >
                  <p>利用区分 *</p>
                  <v-chip
                      v-for="item in useTypeItems"
                      :key="item.value"
                      @click="use_type = item.value;"
                      :color="use_type == item.value ? item.color : 'default'"
                  >
                    {{item.text}}
                  </v-chip>
                </v-col>
              </v-row>
              <v-row class="div-images-upload">
                <v-col cols="auto">
                  <v-btn color="primary" text @click="onAddVideos"
                  >動画追加</v-btn
                  >
                </v-col>
                <v-col>
                  <h4 style="padding-top: 7px">
                    画像数：{{ inputVideosUpload.videos.length }}
                  </h4>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed @click.native="close()">キャンセル</v-btn>
          <v-btn depressed color="primary" @click="uploadVideos"
          >アップロード</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Invisible File Input -->
    <input
        ref="videosUploader"
        class="d-none"
        type="file"
        multiple
        accept="video/mp4,video/x-m4v,video/*"
        @change="addVideos"
        @click="$refs.videosUploader.value = null"
    />

    <!-- Show Error Element -->
    <v-snackbar v-model="snackbar" top left timeout="-1">
      <div>アップロードできない下記のファイルを</div>
      <div>再度アップロードしてください。</div>
      <h4 v-for="(item, i) in errorFileNames" :key="i">{{ item }}</h4>
      <template v-slot:action="{ attrs }">
        <v-btn color="pink" text v-bind="attrs" @click="snackbar = false"
        >閉じる</v-btn
        >
      </template>
    </v-snackbar>

    <!-- Uploading Overlay -->
    <v-dialog v-model="uploadingDialog" width="initial" persistent>
      <div class="overlay-content">
        <h4 class="mb-3">
          処理中です。戻るや画面更新やブラウザ閉じる操作を行わないでください。
        </h4>
        <div v-for="(item, index) in uploadStatus" :key="index">
          <v-progress-circular
            v-if="item.status === 'uploading'"
            size="22"
            indeterminate
            color="primary"
          ></v-progress-circular>
          <v-icon v-if="item.status === 'success'" color="green">mdi-check-circle</v-icon>
          <v-icon v-if="item.status === 'error'" color="red">mdi-alert-circle</v-icon>
          <span>{{' ' + (index + 1) + '. ' + item.name}}</span>
          <v-progress-linear v-model="item.uploadRate" height="25">
            <strong>{{ Math.ceil(item.uploadRate) }}%</strong>
          </v-progress-linear>
          <br/>
        </div>
      </div>
    </v-dialog>
  </div>
</template>
<script>
import { store } from "@/store";
import S3Axios from "@/utils/s3Axios";
export default {
  name: "VideoUploadDialog",
  props: ["value", "plantId", "folderId"],
  data() {
    return {
      uploadingDialog: false,
      snackbar: false,
      uploadFolderId: this.folderId,
      inputVideosUpload: {
        videos: [],
      },
      uploadStatus: [],
      errorFileNames: [],
      useTypeItems: [
        { text: "工事", value: "1construction", color: "purple lighten-1" },
        { text: "査定", value: "2assessment", color: "green lighten-1" },
        { text: "メンテ", value: "3maintenance", color: "orange lighten-1" },
        { text: "ドローン", value: "4drone", color: "light-blue accent-4" },
      ],
      use_type: "",
      folder: null,
      s3Axios: new S3Axios(this.axios).s3Axios
    };
  },
  methods: {
    createFolder() {
      let dateString;
      const date = this.inputVideosUpload.videos[0].lastModifiedDate;
      if (date) {
        const ss = String(date.getSeconds()).padStart(2, '0');
        const mm = String(date.getMinutes()).padStart(2, '0');
        const hh = String(date.getHours()).padStart(2, '0');
        const dd = String(date.getDate()).padStart(2, '0');
        const MM = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
        const yyyy = date.getFullYear();
        dateString = yyyy + '-' + MM + '-' + dd + ' ' + hh + ':' + mm + ':' + ss;
      }
      const body = {
        plant_id: this.plantId,
        type: 'video',
        use_type: this.use_type,
        property: {
          shooting_date: dateString,
        },
      };
      return this.axios.post("/api/folder", body);
    },
    onAddVideos() {
      this.$refs.videosUploader.click();
    },
    addVideos(e) {
      if (!e.target.files || e.target.files.length === 0) return;
      for (const file of e.target.files) {
        // 画像が重複じゃないと画像一覧に追加する。
        if (
            !this.inputVideosUpload.videos.some(
                (x) => x.name === file.name && x.size === file.size
            )
        ) {
          this.inputVideosUpload.videos.push(file);
        }
      }
    },
    async getPresignedUrls(file) {
      const body = {
        'name': file.name,
        'file_size': file.size,
      };
      return this.axios.post("/api/folder/videos/presigned-urls/" + this.uploadFolderId, body);
    },
    async completeMultipartUpload(data) {
      const body = {
        path: data.path,
        uploadId: data.uploadId,
        folderId: this.uploadFolderId
      }
      return this.axios.post("/api/folder/videos/complete-multipart-upload", body);
    },
    async uploadVideos() {
      if (!this.$refs.droneImageUploadForm.validate()||!this.use_type) {
        store.showErrorDialog(
            "利用区分を選択してください。"
        );
        return;
      }
      if (
          !this.inputVideosUpload.videos ||
          this.inputVideosUpload.videos.length === 0
      ) {
        store.showErrorDialog(
            "「動画追加」をクリックし、アップロードしたい動画を追加してください。"
        );
        return;
      }

      if (!this.folderId) {
        try {
          const response = await this.createFolder();
          this.uploadFolderId = response.data.id;
        } catch (error) {
          store.showErrorDialog("エラーが発生しました。管理者に連絡してください。");
          return;
        }
      } else {
        this.uploadFolderId = this.folderId;
      }
      this.snackbar = false;
      this.uploadedFilesNum = 0;
      this.uploadFilesNum = this.inputVideosUpload.videos.length;
      this.uploadingDialog = true;
      this.uploadStatus = this.inputVideosUpload.videos.map(x => ({
        status: 'new',
        uploadedPartCount: 0,
        uploadRate: 0,
        name: x.name,
      }));
      const success_upload_list = [];
      this.errorFileNames = [];

      for (let i = 0; i < this.inputVideosUpload.videos.length; i++) {
        try {
          const video = this.inputVideosUpload.videos[i];
          this.uploadStatus[i].status = 'uploading';
          const response = await this.getPresignedUrls(video);
          const pData = response.data;
          const promises = [];
          for (let j = 0; j < pData.partCount; j++) {
            const start = j * pData.partSize;
            const end = (j + 1) * pData.partSize;
            const blob = j + 1 < pData.partCount ? video.slice(start, end) : video.slice(start);
            promises.push(
              this.s3Axios.put(pData.presignedUrls[j], blob)
                .then(() => {
                  this.uploadStatus[i].uploadedPartCount++;
                  this.uploadStatus[i].uploadRate = 100 * this.uploadStatus[i].uploadedPartCount / pData.partCount;
                })
            );
          }
          await Promise.all(promises);
          await this.completeMultipartUpload(pData);
          this.uploadStatus[i].status = 'success';
          success_upload_list.push(this.uploadStatus[i].name);
        } catch (error) {
          this.uploadStatus[i].status = 'error';
          this.errorFileNames.push(this.uploadStatus[i].name);
        }
      }
      if (this.errorFileNames.length === 0) {
        store.showSuccessDialog("アップロードが完了しました。");
        this.$emit('uploadedVideo', this.uploadFolderId);
        this.close();
      } else {
        //アップロードできない動画があればアップロードできない動画一覧を表示する。
        const errorMsg =
            "アップロードできない下記の動画を再度アップロードしてください。<br>" +
            this.errorFileNames.join("<br>");
        store.showErrorDialog(errorMsg);
        this.snackbar = true;
        this.uploadingDialog = false;
      }
    },
    close() {
      this.uploadingDialog = false;
      this.inputVideosUpload.videos = [];
      this.use_type = '';
      this.$emit("input");
      this.$refs.droneImageUploadForm.reset();
    },
    getFolder() {
      this.axios
          .get("/api/folder/" + this.folderId)
          .then((response) => {
            this.use_type = response.data.use_type;
          });
    },
  },
  watch: {
    value(value){
      if (value && this.folderId){
        this.getFolder();
      }
    }
  },
  created() {
    if (this.folderId){
      this.getFolder();
    }
  }
};
</script>

<style lang="scss">
.div-images-upload {
  border-bottom: 1px solid #ccc;
}
.v-btn-toggle--group > .v-btn.v-btn {
  background-color: #f5f5f5!important;
  color: #1976d2;
  font-weight: bold;
}
.v-chip{
  margin: 5px;
}
.div-images-upload p {
  margin-bottom: 0px;
}
</style>
